import cloneDeep from 'lodash/cloneDeep';
import type { Writable } from 'type-fest';

/**
 * Return an array of unique elements from arr.
 */
export function uniq<T>(arr: readonly T[]): T[] {
  return [...new Set<T>(arr)];
}

/**
 * Deep clone a read-only object and make the clone mutable.
 */
export function mutableDeepClone<T>(obj: T): Writable<T> {
  return cloneDeep(obj) as Writable<T>;
}

export function areArraysEqual<T>(arr1: readonly T[], arr2: readonly T[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}
